<template>
  <article class="content row align-center">
    <div class="large-11 columns">
      <section class="form-section">
        <h1 class="form-section__title">
          {{ $t('ACCOUNT.CHANGE_PASSWORD.TITLE') }}
        </h1>
        <div class="row align-justify">
          <div class="columns small-12 large-4">
            <p class="form-section__description">
              {{ $t('ACCOUNT.CHANGE_PASSWORD.DESCRIPTION') }}
            </p>
          </div>
          <div class="columns small-12 large-7">
            <ElForm
              ref="changePasswordForm"
              class="card"
              :model="changePasswordModel"
              :rules="rules"
              label-position="top"
              @submit.native.prevent="submit"
            >
              <div class="card__block">
                <ErrorsList
                  v-if="nonFieldErrors.length"
                  :errors="nonFieldErrors"
                />
                <ElFormItem
                  :label="$t('ACCOUNT.CHANGE_PASSWORD.CURRENT_PASSWORD')"
                  prop="oldPassword"
                >
                  <ElInput
                    v-model="changePasswordModel.oldPassword"
                    type="password"
                    name="oldPassword"
                    dir="ltr"
                  />
                  <FieldError
                    :errors="changePasswordErrors"
                    field="old_password"
                  />
                </ElFormItem>
                <ElFormItem :label="$t('PASSWORD')" prop="password">
                  <ElInput
                    v-model="changePasswordModel.password"
                    type="password"
                    name="password"
                    dir="auto"
                  />
                  <FieldError
                    :errors="changePasswordErrors"
                    field="new_password"
                  />
                </ElFormItem>
                <ElFormItem :label="$t('PASSWORD_CONFIRM')" prop="checkPass">
                  <ElInput
                    v-model="changePasswordModel.checkPass"
                    type="password"
                    name="checkPass"
                    dir="auto"
                  />
                  <FieldError
                    :errors="changePasswordErrors"
                    field="new_password_confirm"
                  />
                </ElFormItem>
                <ElButton
                  type="primary"
                  native-type="submit"
                  size="large"
                  :loading="isSubmitting"
                >
                  {{ $t('SAVE') }}
                </ElButton>
              </div>
            </ElForm>
          </div>
        </div>
      </section>
    </div>
  </article>
</template>

<script>
import FieldError from '@@/common/FieldError';
import ErrorsList from '@@/common/ErrorsList';

import { Account } from '@/api/api';

import form from '@/mixins/form';
import passwordValidation from '@/mixins/passwordValidation';

export default {
  name: 'ChangePassword',

  components: {
    FieldError,
    ErrorsList,
  },

  mixins: [form, passwordValidation],

  data() {
    return {
      isSubmitting: false,

      changePasswordModel: {
        oldPassword: '',
        password: '',
        checkPass: '',
      },

      changePasswordErrors: {},
      nonFieldErrors: [],
    };
  },

  computed: {
    rules() {
      return {
        oldPassword: {
          required: true,
          message: this.$t('VALIDATION_REQUIRED_ERR'),
          trigger: 'blur',
        },
        password: this.basePasswordRules,
        checkPass: [
          ...this.basePasswordRules,
          {
            validator: this.checkPasswordConfirm('changePasswordModel'),
            trigger: 'blur',
          },
        ],
      };
    },
  },

  methods: {
    errorHandler(errors) {
      this.changePasswordErrors = errors;
      this.nonFieldErrors =
        'non_field_errors' in errors ? errors.non_field_errors : [];
    },

    submit() {
      if (!this.isValid('changePasswordForm')) {
        return false;
      }

      this.isSubmitting = true;
      const { oldPassword, password, checkPass } = this.changePasswordModel;
      return Account.changePassword(
        {},
        {
          old_password: oldPassword,
          new_password: password,
          new_password_confirm: checkPass,
        },
      )
        .then(({ body: { message } }) => {
          if (message) {
            this.$message.success(message);
          }
          this.clearErrors();
          this.reset();
        })
        .catch(({ body: { message, errors } }) => {
          if (errors) {
            this.errorHandler(errors);
          }
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    clearErrors() {
      this.nonFieldErrors = [];
      this.changePasswordErrors = {};
    },

    reset() {
      this.resetForm('changePasswordForm');
    },
  },
};
</script>
